<template>
	<div style="height: 100%;">
		<div v-show="!emptyState" ref="charts" style="height: 100%;"></div>
		<c-empty v-show="emptyState"></c-empty>
	</div>
</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library'
	import * as echarts from 'echarts'

	export default {
		props: {
			data: Array
		},

		data() {
			return {
				...getStore(this, 'digitalStore'),
				emptyState: false
			}
		},

		computed: {
			...mapStore('digitalStore', ['registerChart', 'px', 'charsLength'])
		},

		watch: {
			data() {
				this.init();
			}
		},

		mounted() {
			this.echartsObj = echarts.init(this.$refs.charts);
			this.registerChart(this.echartsObj);
			this.init();
		},

		methods: {
			init() {
				this.emptyState = !this.data.length;
				this.$nextTick(() => {
					let nameWidth = this.px(Math.max.apply(window, this.data.map(item => this.charsLength(item.dimension_name) * 12)));
					let itemWidth = (this.$refs.charts.clientWidth - this.px(100)) / this.data.length;
					let interlace = nameWidth >= itemWidth;
					this.echartsObj.resize();
					this.echartsObj.clear();
					this.echartsObj.setOption({
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							}
						},
						legend: {
							show: true,
							top: this.px(0),
							right: this.px(-4),
							icon: 'rect',
							itemWidth: this.px(14),
							itemHeight: this.px(6),
							textStyle: {
								fontSize: this.px(12),
								color: '#fff'
							}
						},
						grid: {
							top: this.px(10),
							bottom: this.px(interlace ? 50 : 30),
							left: this.px(16 + (Math.max.apply(window, this.data.map(item => item.value.toString().length)) + 2) * 8),
							right: this.px(20)
						},
						yAxis: {
							type: 'value',
							axisLine: {
								show: true,
								lineStyle: {
									color: 'rgba(78,138,177,.5)'
								}
							},
							axisLabel: {
								fontSize: this.px(12),
								color: '#31C6FD'
							}
						},
						xAxis: {
							type: 'category',
							axisLine: {
								show: true,
								lineStyle: {
									color: '#4E8AB1'
								}
							},
							axisLabel: {
								interval: 0,
								lineHeight: this.px(20),
								fontSize: this.px(12),
								color: '#fff'
							},
							splitLine: {
								lineStyle: {
									color: 'rgba(78,138,177,.5)'
								}
							},
							data: this.data.map((item, index) => (interlace && index % 2 ? '\n' : '') + item.dimension_name)
						},
						series: {
							type: 'line',
							color: '#F3EB07',
							data: this.data.map(item => item.value)
						}
					});
				});
			}
		}
	}
</script>

